export default [
  {
    title: 'Dashboards',
    icon: 'HomeIcon',
    // tag: '2',
    tag: '2',
    tagVariant: 'light-warning',

    children: [
      // {
      //   title: 'eCommerce',
      //   route: 'dashboard-ecommerce',
      //   // route: 'empty1',
      //   action: ['read', 'update'],
      //   resource: 'dashboard',
      // },
      // {
      //   title: 'Analytics',
      //   route: 'dashboard-analytics',
      //   // route: 'empty2',
      //   action: ['read', 'update'],
      //   resource: 'dashboard',
      // },
      {
        title: 'Statistics',
        route: 'dashboard-statistics',
        action: ['read', 'update'],
        resource: 'dashboard',
      },
      {
        title: 'Result Dashboard',
        route: 'dashboard-result',
        action: ['read', 'update'],
        resource: 'dashboard',
      },
      // {
      //   title: 'Analytics',
      //   route: 'dashboard-analytics',
      //   action: ['read', 'update'],
      //   resource: 'dashboard',
      // },
    ],
  },
]
